import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './ThankYouForReview.scss';
var ThankYouForReview = /*#__PURE__*/function (_Component) {
  function ThankYouForReview(props) {
    var _this;
    _classCallCheck(this, ThankYouForReview);
    _this = _callSuper(this, ThankYouForReview, [props]);
    _this.state = {
      emails: [],
      submitting: false,
      successMessage: '',
      errorMessage: '',
      existingUsersMessage: '',
      invalidEmail: false,
      tag: ''
    };
    _this.submitEmails = _this.submitEmails.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
    _this.onValidationReject = _this.onValidationReject.bind(_this);
    return _this;
  }
  _inherits(ThankYouForReview, _Component);
  return _createClass(ThankYouForReview, [{
    key: "onValidationReject",
    value: function onValidationReject(values) {
      if (values && values.length && values[0].trim() !== '') {
        this.setState({
          invalidEmail: true
        });
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(emails) {
      this.setState({
        emails: emails,
        invalidEmail: false
      });
    }
  }, {
    key: "handleEmailChange",
    value: function handleEmailChange(input) {
      if (input === ' ' || input === ';' || input === ',') {
        return;
      }
      this.setState({
        tag: input
      });
    }
  }, {
    key: "submitEmails",
    value: function submitEmails() {
      var _this2 = this;
      var emails = this.state.emails;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        newReferralPath = _this$props.newReferralPath,
        location = _this$props.location,
        referredUserType = _this$props.referredUserType;
      if (!emails.length) {
        return;
      }
      this.setState({
        submitting: true
      });
      postRequest(newReferralPath, {
        emails: emails,
        referred_user_type: referredUserType
      }, csrfToken).then(function (_ref) {
        var _ref$data = _ref.data,
          valid = _ref$data.valid,
          invalid = _ref$data.invalid,
          ignored = _ref$data.already_member;
        var errEmails = invalid.map(function (referral) {
          return referral.email;
        });
        var errorMsg = '';
        if (invalid.length) {
          errorMsg = "You've already shared a referral link with ".concat(errEmails.join(', '), ".");
        }
        var successMsg = '';
        if (valid.length) {
          var plural = valid.length !== 1 ? 's' : '';
          var list = valid.map(function (referral) {
            return referral.email;
          }).join(', ');
          successMsg = "Email".concat(plural, " sent! Recipient").concat(plural, ": ").concat(list);
        }
        var existingUsersMsg = '';
        if (ignored.length) {
          var ignoredEmails = ignored.map(function (referral) {
            return referral.email;
          }).join(', ');
          existingUsersMsg = "These referrals are already Clora members: ".concat(ignoredEmails);
        }
        _this2.setState({
          errorMessage: errorMsg,
          successMessage: successMsg,
          existingUsersMessage: existingUsersMsg,
          emails: errEmails,
          submitting: false
        });
        analyticsTrack('Clicked on Send invite emails', {
          location: location,
          referred_user_type: referredUserType
        });
      })["catch"](function () {
        _this2.setState({
          errorMessage: 'Something has gone wrong. Please try again later',
          successMessage: '',
          submitting: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var userFirstName = this.props.userFirstName;
      var _this$state = this.state,
        emails = _this$state.emails,
        successMessage = _this$state.successMessage,
        errorMessage = _this$state.errorMessage,
        existingUsersMessage = _this$state.existingUsersMessage,
        invalidEmail = _this$state.invalidEmail,
        tag = _this$state.tag;
      var addKeys = [9, 13, 32, 186, 188]; // tab, enter, non-printing space, semi-colon, comma
      // From http://emailregex.com/

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return /*#__PURE__*/React.createElement("div", {
        className: "thank-you-for-review style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "header mb-12"
      }, "Thanks for your review!"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-1"
      }, "You can modify your review in the next 48 hours. Clora will publish your review on", userFirstName, "'s profile after that."), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", {
        className: "secondary mb-8"
      }, "Help life science companies build better teams!"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-24"
      }, "Invite fellow hiring managers to acquire talent faster!"), /*#__PURE__*/React.createElement("div", {
        className: "form-inline flex"
      }, /*#__PURE__*/React.createElement(TagsInput, {
        value: emails,
        onChange: this.handleInputChange,
        onChangeInput: this.handleEmailChange,
        className: "form-control email-addresses fs-hide",
        addKeys: addKeys,
        inputProps: {
          placeholder: emails.length === 0 ? 'Enter email addresses...' : '',
          className: emails.length !== 0 && tag === '' ? 'react-tagsinput-input no-width' : ' react-tagsinput-input'
        },
        inputValue: tag,
        addOnBlur: true,
        validationRegex: emailRegex,
        onValidationReject: this.onValidationReject
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.submitEmails,
        className: "employer-submit-emails btn btn-primary text-nowrap ".concat(this.state.submitting ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("span", {
        className: "d-none d-md-block"
      }, "Send "), "Invite")), invalidEmail && /*#__PURE__*/React.createElement("div", {
        className: "text-danger  body-text-3 mt-5"
      }, "Please enter a valid email address."), successMessage && /*#__PURE__*/React.createElement("div", {
        className: "text-primary body-text-3 mt-5"
      }, successMessage), errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "text-danger body-text-3 mt-5"
      }, errorMessage), existingUsersMessage && /*#__PURE__*/React.createElement("div", {
        className: "body-text-3 mt-5"
      }, existingUsersMessage));
    }
  }]);
}(Component);
ThankYouForReview.propTypes = {
  userFirstName: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  referredUserType: PropTypes.string.isRequired
};
export default ThankYouForReview;